import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination as _Pagination } from '@carnica/ui-kit';
import { withRenderFlag } from '@beef/react';
import 'swiper/css';
import classNames from 'classnames/bind';
import { compose } from '@beef/redux';
import { withAutoMetric } from '@beef/auto-metric';
import { enhancedConnect, withClassName } from "../../utils";
import { Navigation as _Navigation } from "./components/Navigation";
import styles from "./styles.pcss";
import { PrimaryContent } from "./components/PrimaryContent";
import { SecondaryContent } from "./components/SecondaryContent";
import { StepsContainer } from "./components/StepsContainer";
import { SecondarySlidesContainer } from "./components/SecondarySlidesContainer";
import { useSteps } from "./useSteps";
import { CollapseContainer } from "../PageSection/CollapseContainer";
var cx = classNames.bind(styles);
var Navigation = withRenderFlag(_Navigation);
var Pagination = withRenderFlag(_Pagination);
var _Steps = function _Steps(_ref) {
  var children = _ref.children,
    type = _ref.type,
    withNavigation = _ref.withNavigation,
    center = _ref.center;
  var slidesLength = React.Children.count(children);
  var _useSteps = useSteps({
      slidesLength: slidesLength
    }),
    isMobile = _useSteps.isMobile,
    nextSlide = _useSteps.nextSlide,
    prevSlide = _useSteps.prevSlide,
    ref = _useSteps.ref,
    setInstance = _useSteps.setInstance,
    handleManualSlideChange = _useSteps.handleManualSlideChange,
    activeSlide = _useSteps.activeSlide,
    activeIndex = _useSteps.activeIndex;
  if (isMobile && type === 'secondary') {
    return /*#__PURE__*/React.createElement(SecondarySlidesContainer, {
      activeIndex: activeIndex,
      "data-t-id": "components-Steps"
    }, React.Children.map(children, function (child, index) {
      return /*#__PURE__*/React.createElement(SecondaryContent, {
        index: index,
        isActive: index === activeIndex
      }, child);
    }));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, withNavigation && /*#__PURE__*/React.createElement(Navigation, {
    nextSlide: nextSlide,
    prevSlide: prevSlide,
    shouldRender: !isMobile
  }), /*#__PURE__*/React.createElement(CollapseContainer, null, /*#__PURE__*/React.createElement(StepsContainer, {
    center: center,
    ref: ref,
    "data-t-id": "components-Steps"
  }, /*#__PURE__*/React.createElement(Swiper, {
    className: cx('carousel-swiper'),
    loop: false,
    onSlideChange: setInstance,
    onSwiper: setInstance,
    slidesPerView: "auto",
    "data-t-id": "components-Steps"
  }, React.Children.map(children, function (child, index) {
    return /*#__PURE__*/React.createElement(SwiperSlide, {
      className: cx('carousel-slide')
    }, /*#__PURE__*/React.createElement(PrimaryContent, {
      className: cx('slide-wrap'),
      index: index,
      isActive: activeIndex === index,
      onClick: function onClick() {
        return handleManualSlideChange(index);
      },
      "data-t-id": "components-Steps"
    }, child));
  })))), /*#__PURE__*/React.createElement(Pagination, {
    activePoint: activeSlide,
    className: cx('pagination'),
    direction: "row",
    points: slidesLength,
    shouldRender: isMobile
  }));
};
export var Steps = compose(enhancedConnect(), withClassName, withAutoMetric.Container(function () {
  return {
    name: 'Steps'
  };
}))(_Steps);